export const loadingTexts: string[] = [
  "Hang tight! We're creating your setup...",
  "Creating your project space...",
  "Connecting the dots...",
  "Adding the finishing touches...",
];

export const cubeActivationBatchCount = 4;
export const cubeActivationBatchDelay = 950;

export enum OnboardingStep {
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  CONFIRM_EMAIL = "CONFIRM_EMAIL",
  SETUP_2FA = "SETUP_2FA",
  SETUP_WORKSPACE = "SETUP_WORKSPACE",
  ADD_PROJECT = "ADD_PROJECT",
}

/*
  - The current flow of the onboarding process from the first step to the last is defined using this array constant.
  - we're also using this constant to calculate the amount of svg components to display for animation & the right step to show in the stepper/progress component. Please add a new value here when adding a new onboarding step.
  - TODO: We have to update this with an appropriate state machine library. Just going with this manual approach temporarily to get something up & running
*/
export const ONBOARDING_FLOW: { id: OnboardingStep }[] = [
  { id: OnboardingStep.CREATE_ACCOUNT },
  { id: OnboardingStep.CONFIRM_EMAIL },
  { id: OnboardingStep.SETUP_2FA },
  { id: OnboardingStep.SETUP_WORKSPACE },
  { id: OnboardingStep.ADD_PROJECT },
];

export const FROM_ONBOARDING_KEY = "from_onboarding"; // to check if the user is coming from the onboarding flow and finish/clean up the flow
export const FROM_REGISTRATION_KEY = "from_registration"; // to check if the user is newly registered and appropriately display the get started cards
export const FROM_RECOVERY_KEY = "from_recovery"; // to check if the user is coming from the recovery flow and appropriately display the password dialog
export const PREV_ONBOARDING_STEP_KEY = "prev_onboarding_step";
export const FROM_COUNTY_SELECT_INPUT = "from_county_select_input";
